const GET_SETTINGS = 'SETTINGS/GET_SETTINGS';

export default {
  GET_SETTINGS,
};
